import { render, staticRenderFns } from "./gzsBase.vue?vue&type=template&id=d312a7c2&scoped=true"
import script from "./gzsBase.vue?vue&type=script&lang=js"
export * from "./gzsBase.vue?vue&type=script&lang=js"
import style0 from "./gzsBase.vue?vue&type=style&index=0&id=d312a7c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d312a7c2",
  null
  
)

export default component.exports